import { create } from "zustand";
import type { ReactNode } from "react";

interface TopbarState {
  content: ReactNode | null;
  setContent: (content: ReactNode | null) => void;
}

/** レジ画面などが現在の卓情報をヘッダーに表示するための差し込み口。 */
export const useTopbarStore = create<TopbarState>((set) => ({
  content: null,
  setContent: (content) => set({ content }),
}));
